import React, { useEffect, useState } from "react";
import { ISorter } from "../../models/interfaces/ISorter";
import CpntDataTable from "../../components/dataTable/CpntDataTable";
import { ITitle } from "../../models/interfaces/ITitle";
import { ILocation } from "../../models/interfaces/ILocation";
import { IFilterSociete, dtoToFilter, filterToQuery, getDefaultFilterSociete } from "../../models/interfaces/IFilterSociete";
import { useFetchSocietesQuery } from "../../redux/slice/api/FO/societeApi";
import SocietesFilter from "./components/SocietesFilter";
import HtmlRenderTypeActivite from "../../components/HtmlRender/HtmlRenderTypeActivite";
import { useKeycloak } from "@react-keycloak/web";
import CpntPagination from "../../components/CpntPagination";
import { ISociete } from "../../models/interfaces/ISociete";
import SpinnerEditeurPro from "./components/SpinnerEditeurPro";


const PageSocietes: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterSociete>();
  const [searchParams, setSearchParams] = useState<IFilterSociete>();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isDescending, setIsDescending] = useState<boolean>();
  const [sortField, setSortField] = useState("");
  const [numberOfResults, setNumberOfResults] = useState<number|null>(null);
  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)
 
  //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  
  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterSocietes");
    const storedSorter = localStorage.getItem("ISortStore");

    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      setListFilter(JSON.parse(storedFilter));
    } else {
      setListFilter(getDefaultFilterSociete());
    }

    if (storedSorter !== null && storedSorter !== undefined) {
      const currSorter:ISorter = JSON.parse(storedSorter);
      currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
      currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterSociete()) {
      const _filter: IFilterSociete = filterToQuery({
        ...listfilter,
        ...(sortField && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 0 && { Limit: limit }),
        ...(offset >= 0 && limit >= 0 && { Offset: offset })
      });
      setSearchParams(_filter);
      localStorage.setItem("IFilterSocietes",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  const { data: SocietesResult, isFetching, error } = useFetchSocietesQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined || listfilter === undefined,
  });

  useEffect(() => {
    setNumberOfResults(SocietesResult?.Quantite ?? null);
  }, [SocietesResult]);
  
  const applyFilter = (data: IFilterSociete) => {
    setListFilter(data);
    setOffset(0);
    setLimit(10);
  }

  const actions: ILocation[] = [
    {
      PathsName: { Voir: "/societedetails/[[IdSociete]]" },
      State: { type_access: "" },
      ClassName: "bi-receipt fs-5 mb-2",
    },
  ];

  const dataHeaderName: ITitle[] = [
    {
      Id: "IdSociete",
      Name: "IdSociete",
      Class: "",
      sorter: (a: ISociete, b: ISociete) =>
        a?.IdSociete?.localeCompare(b?.IdSociete),
    },
    {
      Id: "RaisonSociale",
      Name: "Raison Sociale",
      Class: "",
      sorter: (a: ISociete, b: ISociete) =>
        a?.RaisonSociale?.localeCompare(b?.RaisonSociale),
    },
    {
      Id: "Nationalite",
      Name: "Nationalite",
      Class: "",
      sorter: (a: ISociete, b: ISociete) =>
        a?.Nationalite?.localeCompare(b?.Nationalite),
    },
    {
      Id: "IdTypeActivite",
      Name: "Type d'Activite",
      Class: "",
      sorter: (a: ISociete, b: ISociete) =>
        a?.IdTypeActivite?.localeCompare(b?.IdTypeActivite),
    },
  ];


  const dataItemsStyle = {
    IdSociete: "",
    RaisonSociale: "",
    Nationalite: "",
    IdTypeActivite: <HtmlRenderTypeActivite />,
  };

  return (
    <>
     <div className="container text-start ">
     <div className="col text-center">
            <h2 className="h3lpe mb-0">Gestion Societes</h2>
          </div>
      <div className="row card mb-3 mt-2">
          {searchParams && (
            <>
              <SocietesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
            {/* Facettes */}
            </>
          )}
           
        </div> 
        <div className="row ">
          {numberOfResults !== null && SocietesResult?.Societes && 
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{numberOfResults}&nbsp;</b>
            </div>
          }
          {isFetching ? (
          <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            SocietesResult?.Societes && numberOfResults !== null && numberOfResults > 0 &&
              <>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={SocietesResult && SocietesResult.Societes ? [...SocietesResult.Societes] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PageSocietes"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              </>
          )}
        </div>
      </div>
    </>
  );
};

export default PageSocietes;
